import { AppThunkContext, requestMiddleware, rootReducer } from '@fullstory/redux';
import { NetworkController } from '@fullstory/util/xhr';
import { Flags } from '@fullstory/client-api';
import { applyMiddleware, createStore } from 'redux';
import thunk from 'redux-thunk';

// NB(vasilios): Fixes "error TS2742: inferred type cannot be named without a reference"
// See https://github.com/aspect-build/rules_ts/issues/159 for more information.
import type {} from '@fullstory/redux-util/types';

export const xhr = new NetworkController();
export const TEST_ORG_ID = 'testOrg';

// This helper creates a fully setup redux store
// in case you want to test a redux store in isolation.
export const createTestReduxStore = ({
  flags = new Flags(),
  initialState = {},
  thunkContext = {},
  networkController,
}: {
  flags?: Flags;
  initialState?: any;
  thunkContext?: any;
  networkController?: NetworkController | null;
}) =>
  createStore(
    rootReducer,
    initialState,
    applyMiddleware(
      thunk.withExtraArgument({ ...defaultThunkContext, ...thunkContext, flags: () => flags }),
      requestMiddleware(networkController || xhr),
    ),
  );

const defaultThunkContext: Omit<AppThunkContext, 'flags'> = {
  xhr: () => xhr,
  orgId: () => TEST_ORG_ID,
};
